import React from 'react'
import { useDispatch } from 'react-redux'
import { usePageLayout } from '../../../util/usePageLayout/usePageLayout'
import PageLayoutOrganism from '../../../stories/organisms/PageLayout/PageLayout'
import { useAppSelector } from '../../../state/reducers/types'
import fetchAndSetRecruiterInfo from '../../../util/fetch-and-set-recruiter-info/fetchAndSetRecruiterInfo'
import { selectUser } from '../../../state/selectors/user/user'
import { State } from '../../../state/reducers'
import fetchAndSetLastRejectedJob from '../../../util/fetch-and-last-rejected-job/fetchAndSetLastRejectedJob'

type PageLayoutProps = {
  withNavigation?: boolean
  title?: string
  className?: string
  shouldFetchRecruiterInfo?: boolean
  hideDialog?: boolean
  children?: React.ReactNode
  reportRejectedJobs?: boolean
}

const PageLayout: React.FunctionComponent<PageLayoutProps> = ({ children, shouldFetchRecruiterInfo = true, hideDialog, reportRejectedJobs = false, ...props }) => {
  const lastRejectedJob = useAppSelector((state: State) => state.dashboard?.lastRejectedJob)
  const pageLayoutProps = usePageLayout()
  const dispatch = useDispatch()

  const userInfo = useAppSelector(selectUser)

  React.useEffect(() => {
    async function performFetches() {
      const allPromises = []
      if (!userInfo?.isInitialized && shouldFetchRecruiterInfo) {
        allPromises.push(fetchAndSetRecruiterInfo({ dispatch, hideDialog }))
      }
  
      if (reportRejectedJobs) {
        allPromises.push(fetchAndSetLastRejectedJob({ dispatch }))
      }

      await Promise.all(allPromises)
    }
    performFetches()
  }, [])

  return (
    <PageLayoutOrganism {...pageLayoutProps} lastRejectedJob={lastRejectedJob} {...props}>
      {children}
    </PageLayoutOrganism>
  )
}

export default PageLayout
